import debounce from "lodash/debounce";
import React from "react";
import { connect } from "react-redux";
import { EVT_WIN_BEFOREUNLOAD } from "../../lib";
import { persistStore } from "../../services";
import { AppState } from "../../store";
import { Loading } from "../Loading";

export const APP_REHYDRATE = "app/REHYDRATE";
type Payload = { name: string; value: any };
function rehydrate(payload: Payload) {
    return {
        payload,
        type: APP_REHYDRATE,
    };
}

const mapDispatch = { rehydrate };
const mapStateToProps = (state: AppState) => ({ state });

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatch;
type OwnProps = {
    children: JSX.Element | JSX.Element[];
};
type Props = StateProps & DispatchProps & OwnProps;
type State = {
    loaded: boolean;
};

class AppRehydrate extends React.Component<Props, State> {
    private fetching: boolean;
    private save: ReturnType<typeof debounce>;

    constructor(props: Props) {
        super(props);

        this.state = {
            loaded: false,
        };

        this.fetching = false;
        this.save = debounce(this._save, 0);

        window.addEventListener(EVT_WIN_BEFOREUNLOAD, () => {
            this.save.flush();
        });
    }

    componentDidMount() {
        this.fetch();
    }

    componentDidUpdate() {
        this.save();
    }

    async fetch() {
        if (this.fetching) {
            return;
        }

        this.fetching = true;
        await this.fetchSet("reader");
        await this.fetchSet("settings");
        await this.fetchSet("autocomplete");
        this.fetching = false;

        this.setState({ loaded: true });
    }

    private async fetchSet(name: string) {
        const { value } = await persistStore.get(name);
        if (value) {
            this.props.rehydrate({ name, value: JSON.parse(value) });
        }
    }

    _save() {
        const { state } = this.props;

        //@ts-ignore
        persistStore.set("reader", JSON.stringify(state.reader.toJS()));
        //@ts-ignore
        persistStore.set("settings", JSON.stringify(state.settings.toJS()));
        persistStore.set(
            "autocomplete",
            //@ts-ignore
            JSON.stringify(state.autocomplete.toJS())
        );
    }

    render() {
        if (!this.state.loaded) {
            return <Loading />;
        }

        return this.props.children;
    }
}

export default connect(mapStateToProps, mapDispatch)(AppRehydrate);
